import React from "react";
import { FaShoppingCart, FaRupeeSign, FaWallet } from "react-icons/fa";

const ReSellerDashboard = () => {
  return (
    <div className="p-6">
      {/* Top Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white rounded-xl shadow p-6">
          <div className="flex items-center justify-between">
            <h3 className="text-gray-500">Total Orders</h3>
            <FaShoppingCart className="text-indigo-600 text-xl" />
          </div>
          <p className="text-3xl font-bold mt-3">38</p>
        </div>

        <div className="bg-white rounded-xl shadow p-6">
          <div className="flex items-center justify-between">
            <h3 className="text-gray-500">Total Commission</h3>
            <FaRupeeSign className="text-green-600 text-xl" />
          </div>
          <p className="text-3xl font-bold mt-3">₹9,850</p>
        </div>

        <div className="bg-white rounded-xl shadow p-6">
          <div className="flex items-center justify-between">
            <h3 className="text-gray-500">Wallet Balance</h3>
            <FaWallet className="text-yellow-600 text-xl" />
          </div>
          <p className="text-3xl font-bold mt-3">₹2,450</p>
        </div>
      </div>

      {/* Recent Orders Table */}
      <div className="bg-white rounded-xl shadow p-6">
        <h2 className="text-xl font-semibold mb-4">Recent Orders</h2>

        <table className="w-full text-left">
          <thead>
            <tr className="text-gray-500 border-b">
              <th className="py-2">Order ID</th>
              <th>Status</th>
              <th>Commission</th>
            </tr>
          </thead>

          <tbody>
            <tr className="border-b">
              <td className="py-3">#RS-1001</td>
              <td className="text-green-600">Delivered</td>
              <td>₹320</td>
            </tr>

            <tr>
              <td className="py-3">#RS-1002</td>
              <td className="text-yellow-600">Processing</td>
              <td>₹180</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReSellerDashboard;
